import React, { useState, useEffect } from 'react';
import { Coffee, PlayCircle } from 'lucide-react';
import BreaksTracker from './BreaksTracker';
import PermissionTracker from './PermissionTracker';
import LeaveForm from './LeaveForm';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function BreaksTab() {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const r = await fetch(`${API_URL}/api/staff/today-summary`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (r.ok) setSummary(await r.json());
      } catch {}
    })();
  }, []);

  return (
    <div className="space-y-3" data-testid="breaks-tab">
      <div className="bg-white rounded-xl p-3 shadow-sm" data-testid="breaks-summary-card">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Coffee size={16} className="text-amber-600" />
            <h3 className="font-semibold text-sm">Today's Summary</h3>
          </div>
          {summary?.ongoing_break && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-orange-100 text-orange-700 text-[10px] font-semibold rounded-full capitalize">
              <PlayCircle size={10} /> {summary.ongoing_break} ongoing
            </span>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2 mt-3">
          <Mini label="Breaks today" value={summary?.breaks_today ?? '—'} tone="text-amber-700" />
          <Mini label="Status" value={summary?.ongoing_break ? 'Active' : 'Idle'} tone="text-emerald-700" />
        </div>
      </div>

      <BreaksTracker />
      <PermissionTracker />
      <LeaveForm />
    </div>
  );
}

function Mini({ label, value, tone }) {
  return (
    <div className="bg-gray-50 rounded-lg p-2">
      <p className="text-[10px] text-gray-500 uppercase">{label}</p>
      <p className={`text-lg font-bold ${tone || 'text-gray-900'}`}>{value}</p>
    </div>
  );
}
